import { Col, Container, Row } from "react-bootstrap";
import PageTitleBar from "../../Components/Site/PageTitleBar";
import ButtonLinkElement from "../../Components/Common/ButtonLinkElement";

const BookingDone = (props) => {

  return (
    <>

      <div className="big-page-title">
        <section id="page-title-bar" className="page-title-bar">
          <Container>
            <Row>
              <Col md={12} lg={12}>
                <div className="content">
                  Booking Completed
                  <h1>Your Booking has been confirmed.</h1>
                  <ButtonLinkElement to={"/appointments"} text="Show Appointments" variant="primary" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>

    </>
  );
};

export default BookingDone;
